import React, { ReactNode } from 'react';

interface PageTitleProps {
    title: string;
    subtitle?: string | ReactNode;
    actions?: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, actions }) => {
    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
                {subtitle && (
                    <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</div>
                )}
            </div>
            {actions && <div className="mt-4 md:mt-0">{actions}</div>}
        </div>
    );
};

export default PageTitle;
